module.exports = __webpack_public_path__ + "img/qiita-square.43ef3dfe.png";